appSocial.controller('leaderPausePage', [
    '$scope', '$state', '$ionicModal', 'SocialLocaleService', 'SocialUtils', 'trader', 'SocialActionService', 'SocialTypes',
    function ($scope, $state, $ionicModal, SocialLocaleService, SocialUtils, trader, SocialActionService, SocialTypes) {
        class LeaderPausePage {
            constructor() {
                this.translation = SocialLocaleService.translation;
                this.$scope = $scope;
                this.$state = $state;

                /**
                 * @type {SocialUtils}
                 */
                this.utils = SocialUtils;

                /**
                 * @type {SocialActionService}
                 */
                this.actionService = SocialActionService;

                this.actions = SocialTypes.CopyAction;

                this.trader = trader;
                this.action = $state.params.action;

                this.modal = {
                    isError: false,
                    textTitle: '',
                    textContent: '',
                    state: false,
                    isProcess: false
                }
            }

            callAction() {
                // send to children component event
                this.$scope.$broadcast(this.action);
            }

            onSuccess() {
                this.modal.isProcess = false;

                this.modal.textTitle = (this.action === this.actions.Pause)
                    ? 'Copy action paused'
                    : 'Copy action resumed';

                this.modal.textContent = (this.action === this.actions.Pause)
                    ? `The leader ${this.trader.fullname} <br/> is temporarily paused.`
                    : `The leader ${this.trader.fullname} <br/> returned to be copied.`

                this.modal.actionText = 'Continue';

                this.modal.back = {
                    state: 'root.app.socialPortfolio',
                    params: {category: 'current', id: this.trader.id}
                }
            }

            onFail(error) {
                this.modal.isError = true;
                this.modal.state = true;
                this.modal.isProcess = false;
                this.modal.textTitle = (this.action === this.actions.Pause)
                    ? 'Failed to pause'
                    : 'Failed to resume';
                this.modal.textContent = this.translation.messages[error.data.type] || 'Something went wrong';
                this.modal.actionText = 'Continue';
            }

            onActionStart() {
                this.modal.isError = false;
                this.modal.state = true;
                this.modal.isProcess = true;
                this.modal.textTitle =
                    (this.action === this.actions.Pause)
                        ? 'Pause copy is processing'
                        : 'Resume copy is processing';
            }
        }

        return new LeaderPausePage()
    }]);

